import React, { Component } from 'react';
import './App.css';
import Tabs from '@material-ui/core/Tabs';
import {Route, Switch} from "react-router";
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import {Link} from "react-router-dom";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import UsefulMachines from "./Pages/UsefulMachines";
import logo from './logo.svg';
import excavator from './bagrik.svg';
import MuckTruck from "./Pages/MuckTruck";
import MaxTruck from "./Pages/MaxTruck";
import ETruck from "./Pages/ETruck";
import HMaxTruck from "./Pages/HMaxTruck";
import Accessories from "./Pages/Accessories";
import PriceList from "./Pages/PriceList";
import { IntlProvider, addLocaleData } from "react-intl";
import EN from './Locales/EN';
import CZ from './Locales/CZ';
import SK from './Locales/SK';

import * as czech from 'react-intl/locale-data/cs';
import * as slovak from 'react-intl/locale-data/sk';

addLocaleData([...czech, ...slovak]);

export const Locales = {
	SK: 'sk',
	CZ: 'cs',
	EN: 'en'
};

class App extends Component {
	state = {
		page: 0,
		locale: 'sk'
	};

	componentDidMount() {
		this.updateTabs();
	}

	updateTabs = () => {
		let page = 0;

		switch (window.location.hash) {
			case '#/':
			case '#/home':
				page = 0;
				break;
			case '#/kontakt':
				page = 3;
				break;
			case '#/cennik':
				page = 2;
				break;
			case '#/uzitocne-stroje':
			default:
				page = 1;
				break;
		}

		this.setState({ page });
	};

	handleChange = (event, value) => {
		this.setState({ page: value });
	};

	changeLocale = (locale) => {
		this.setState({ locale });
	};

	render() {
		const { page, locale } = this.state;
		const messages = locale === Locales.EN ? EN : locale === Locales.CZ ? CZ : SK;

		return (
			<div className="App">
				<IntlProvider key={locale} locale={locale} messages={messages}>
					<MuiThemeProvider theme={theme}>
						<header>
							<div className='header'>
								<img decoding="async" src={logo} alt='logo' height={841.89 * 0.1} width={1190.55 * 0.1} />
								<h1 className='main-title'>PROGRES PLUS, s.r.o.</h1>
								<img decoding="async" src={excavator} alt='logo' height={841.89 * 0.1} width={1190.55 * 0.1} />
							</div>
							<AppBar position="static" color="default">
								<Tabs
									className="tabs"
									value={page || 0}
									onChange={this.handleChange}
									indicatorColor="primary"
									textColor="secondary"
									centered
								>
									<Tab label="Domov" component={Link} to="/home" />
									<Tab label="Užitočné stroje" component={Link} to="/uzitocne-stroje" />
									<Tab label="Cenník" component={Link} to="/cennik" />
									<Tab label="Kontakt" component={Link} to="/kontakt" />
								</Tabs>
							</AppBar>
						</header>

						<main className='content'>
							<Switch>
								<Route exact path="/" component={Home} />
								<Route exact path="/home" component={Home} />
								<Route
									exact
									path="/uzitocne-stroje"
									render={(props) => <UsefulMachines {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
								<Route exact path="/cennik" component={PriceList} />
								<Route exact path="/kontakt" component={Contact} />

								<Route
									exact
									path="/muck-truck"
									render={(props) => <MuckTruck {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
								<Route
									exact
									path="/max-truck"
									render={(props) => <MaxTruck {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
								<Route
									exact
									path="/e-truck"
									render={(props) => <ETruck {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
								<Route
									exact
									path="/h-max"
									render={(props) => <HMaxTruck {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
								<Route
									exact
									path="/prislusenstvo"
									render={(props) => <Accessories {...props} locale={locale} changeLocale={this.changeLocale} />}
								/>
							</Switch>
						</main>

						<footer className='footer'>
							<p>Copyright © 2015 - Všetky práva vyhradené</p>
							<p>
								PROGRES PLUS, s.r.o.  -{' '}
								<a
									href='http://orsr.sk/vypis.asp?ID=53470&SID=7&P=1&fbclid=IwAR2E-ZXUNX6rexKICtotHYqQQrBMj-EJ7z4lRcqwFRmN0a4Uyc1tezeFcOI'
									target='_blank'
									rel="noopener noreferrer"
								>
									Obchodný register
								</a>
							</p>
						</footer>
					</MuiThemeProvider>
				</IntlProvider>
			</div>
		);
	}
}

export default App;
